import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { MessageDetails } from "./MessageDetails";
import { MessageProfileInfo } from "./MessageProfileInfo";
export var MessageReceived = React.memo(function (_a) {
    var messageInfo = _a.messageInfo;
    return (React.createElement("div", { className: "chat-message" },
        React.createElement(MessageProfileInfo, { messageInfo: messageInfo }),
        React.createElement("div", { className: "" + IdStyles.CoopChatReceivedContainer },
            React.createElement(MessageDetails, { messageInfo: messageInfo }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/MessageReceived.tsx
// module id = 2579
// module chunks = 3